/*
 * Kalmix custom code
 * File: assets/kmx-home-record.js
 * Version: 1008.3
 * History:
 * - 1008.3 Playback resumes when the visitor leaves the act after pausing and comes
 *   back. Reports the clip's progress to the right-hand pager (KMX.progress). Trail
 *   width brought in line with 05 / 06 (1.8px, up to 3px near the head).
 * - 1008.2 Ice-blue trajectory with rounded corners (the loop becomes a smooth
 *   track: each turn is a quadratic arc), fewer doubled-back streets (edges already
 *   used cost more, A-B-A spikes removed). The two knowledge dots sit on the track
 *   in open space, so the line runs through them. Scene videos preload: the next
 *   clip loads in the background and a tab's clip starts loading on hover / focus.
 * - 1008.1 (rev) Planned loop: the trajectory follows a closed route around the
 *   player (gap left of it, band above, right side, band below), found with a
 *   shortest-path search on the street grid where streets behind the player cost
 *   ~40x and the text block (eyebrow to buttons) / header band are closed; one fixed stretch on the
 *   right is the amber tunnel. Falls back to the random walk if no loop is found.
 * - 1008.1 The walker prefers streets outside the player (passing behind it only
 *   when there is no other way), so the trail stays visible; longer, thicker tail.
 * - 1007.4 Light white-model city: white roofs, light / mid walls, soft ground
 *   shadows; nearby blocks warm up with a faint green tint as the head passes.
 *   The trail is always drawn above the blocks (decorative; readability over
 *   strict occlusion); blocks are kept low and streets wide. Trajectory deep green, tunnel stretches amber dashes. The walker keeps
 *   out of the text column and the header band; it may pass behind the player.
 * - 1007.3 Background city (decorative): a translucent isometric white-model city
 *   is generated once and cached; a short trajectory wanders along its streets,
 *   its tail fades out over ~3 s, some street stretches render as an amber dashed
 *   "tunnel", and blocks near the head brighten and slowly dim again. Runs only
 *   while the act is visible; reduced motion shows the still city. Route map
 *   removed. Player logic unchanged (incl. the 1007.2 autoplay fix).
 * - 1007.1 Initial delivery of 04 RECORD. Scene player for the GT-01 videos with
 *   tabs, progress, auto-advance, DR callout (6–51 s of the 54 s tunnel clip),
 *   readout, column alignment and knowledge-dot flipping.
 */
(function () {
  'use strict';

  function initRecord(sec) {
    if (sec.__kmxInit) return; sec.__kmxInit = true;
    var KMX = window.KMX || { reduce: false, onEnter: function () {}, onVisible: function () {} };
    var reduce = KMX.reduce;
    var q = function (k) { return sec.querySelector('[data-k="' + k + '"]'); };
    var vids = Array.prototype.slice.call(sec.querySelectorAll('.kmx-rec__video'));
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('.kmx-rec__tab'));
    var dr = sec.querySelector('.kmx-rec__dr');
    var pp = sec.querySelector('.kmx-rec__pp');
    var player = sec.querySelector('.kmx-rec__player');
    var copy = sec.querySelector('.kmx-rec__copy');
    var mq = window.matchMedia('(max-width: 860px)');
    if (!vids.length) return;

    var cur = -1, visible = false, wantPlay = !reduce;

    /* ---------- 背景：白模城市 + 游走轨迹 ---------- */
    var cv = sec.querySelector('.kmx-rec__city'), cx2 = cv ? cv.getContext('2d') : null;
    var cache = document.createElement('canvas'), W = 0, H = 0, DPR = 1, A = 22, B = 4;
    var blds = [], ox = 0, oy = 0, N = 0;
    var walker = null, trail = [], running = false, lastT = 0;
    function rnd(a, b) { return a + Math.random() * (b - a); }
    function P(u, v, h) { return [ox + (u - v) * A, oy + (u + v) * A / 2 - (h || 0) * A]; }
    function face(c, pts, fill, line) {
      c.beginPath(); c.moveTo(pts[0][0], pts[0][1]); for (var i = 1; i < pts.length; i++) c.lineTo(pts[i][0], pts[i][1]); c.closePath();
      c.fillStyle = fill; c.fill(); c.strokeStyle = line; c.stroke();
    }
    function drawB(c, b, k) {   // 白模：白色屋顶、两侧墙一明一暗；k 为提亮系数 0–1
      var u0 = b.u0, v0 = b.v0, u1 = b.u1, v1 = b.v1, h = b.h;
      var mix = function (r, g, bb, tr, tg, tb) { return 'rgb(' + Math.round(r + (tr - r) * k) + ',' + Math.round(g + (tg - g) * k) + ',' + Math.round(bb + (tb - bb) * k) + ')'; };
      var line = 'rgba(15,28,36,' + (.09 + .06 * k) + ')';
      face(c, [P(u0, v1, 0), P(u1, v1, 0), P(u1, v1, h), P(u0, v1, h)], mix(226, 230, 228, 212, 230, 244), line);
      face(c, [P(u1, v0, 0), P(u1, v1, 0), P(u1, v1, h), P(u1, v0, h)], mix(240, 242, 240, 224, 238, 250), line);
      face(c, [P(u0, v0, h), P(u1, v0, h), P(u1, v1, h), P(u0, v1, h)], mix(253, 253, 252, 238, 247, 255), line);
    }
    function shadow(c, b) {   // 地面投影：向右下偏移的柔和平行四边形
      var s = b.h * .55;
      c.beginPath();
      var a = P(b.u1, b.v0, 0), bq = P(b.u1 + s, b.v0 + s * .2, 0), cq = P(b.u1 + s, b.v1 + s * .2, 0), d = P(b.u1, b.v1, 0), e = P(b.u0, b.v1, 0), f = P(b.u0 + s * .4, b.v1 + s * .5, 0);
      c.moveTo(a[0], a[1]); c.lineTo(bq[0], bq[1]); c.lineTo(cq[0], cq[1]); c.lineTo(f[0], f[1]); c.lineTo(e[0], e[1]); c.lineTo(d[0], d[1]); c.closePath();
      c.fillStyle = 'rgba(15,28,36,.045)'; c.fill();
    }
    function buildCity() {
      if (!cv) return;
      DPR = Math.min(window.devicePixelRatio || 1, 2);
      W = cv.offsetWidth; H = cv.offsetHeight; if (!W || !H) return;
      A = mq.matches ? 18 : 22;
      cv.width = W * DPR; cv.height = H * DPR; cache.width = cv.width; cache.height = cv.height;
      ox = W * .6; oy = H * .5 - H * .55;
      // 覆盖画面所需的 u / v 范围
      N = Math.ceil((W / A + H * 2 / A) / 2) + B;
      blds = [];
      var u0g = -N, u1g = N + Math.ceil(H / A * 1.2);
      for (var bu = Math.floor(u0g / B) * B; bu < u1g; bu += B) for (var bv = Math.floor(u0g / B) * B; bv < u1g; bv += B) {
        var c = P(bu + B / 2, bv + B / 2, 0); if (c[0] < -A * 6 || c[0] > W + A * 6 || c[1] < -A * 10 || c[1] > H + A * 6) continue;
        if (Math.random() < .12) continue;   // 偶有空地
        var split = Math.random() < .55;
        var m = .7, parts = split ? [[m, m, B / 2 - .2, B - m], [B / 2 + .2, m, B - m, B - m]] : [[m, m, B - m, B - m]];
        if (split && Math.random() < .5) parts = [[m, m, B - m, B / 2 - .2], [m, B / 2 + .2, B - m, B - m]];
        parts.forEach(function (q) {
          var tall = Math.random() < .14;
          blds.push({ u0: bu + q[0], v0: bv + q[1], u1: bu + q[2], v1: bv + q[3], h: tall ? rnd(1.8, 3.2) : rnd(.35, 1.2), g: 0 });
        });
      }
      blds.sort(function (a, b) { return (a.u0 + a.v0) - (b.u0 + b.v0); });
      var c2 = cache.getContext('2d'); c2.setTransform(DPR, 0, 0, DPR, 0, 0); c2.clearRect(0, 0, W, H); c2.lineWidth = .7;
      blds.forEach(function (b) { shadow(c2, b); });
      blds.forEach(function (b) { drawB(c2, b, 0); });
      // 由屏幕坐标反算 u / v，取最近的路口（画面右下部）
      measureKeepOut();
      // 起点：播放器下方的空当
      var pr = player.getBoundingClientRect(), sr0 = cv.getBoundingClientRect();
      var tx = (pr.left + pr.right) / 2 - sr0.left, ty = Math.min(H * .95, (pr.bottom - sr0.top + H) / 2), d1 = (tx - ox) / A, d2 = 2 * (ty - oy) / A;
      var su = Math.round(((d1 + d2) / 2) / B) * B, sv = Math.round(((d2 - d1) / 2) / B) * B;
      walker = { u: su, v: sv, du: 1, dv: 0, tu: su + B, tv: sv, tun: false };
      planLoop();
      if (track) { var t0 = trackAt(0); walker = { u: t0[0], v: t0[1], tun: false, s: 0, onTrack: true }; }
      trail = [];
      drawFrame(performance.now());
    }
    // 轨迹不进入播放器和左栏文字的区域（画在那里会被挡住或干扰阅读）
    var keepOut = [], topY = 0, pRect = null;
    function inPlayer(x, y) { return pRect && x > pRect[0] && x < pRect[2] && y > pRect[1] && y < pRect[3]; }
    function measureKeepOut() {
      keepOut = []; if (!cv) return;
      var sr = cv.getBoundingClientRect();
      // 页头以下才算可用区域
      var hdr = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--kmx-hdr-h')) || 70;
      topY = hdr + 40;
      if (player) { var r0 = player.getBoundingClientRect(); pRect = [r0.left - sr.left - 10, r0.top - sr.top - 10, r0.right - sr.left + 10, r0.bottom - sr.top + 10]; }
      // 左栏只按文字实际占用的范围（小标顶 → 按钮底）设禁区，文字上方空白和页边仍可通行
      if (copy) {
        var kids = Array.prototype.slice.call(copy.children).filter(function (k) { return k.offsetHeight; });
        if (kids.length) {
          var t = kids[0].getBoundingClientRect(), bt = kids[kids.length - 1].getBoundingClientRect(), cr = copy.getBoundingClientRect();
          keepOut.push([cr.left - sr.left - 16, t.top - sr.top - 20, cr.right - sr.left + 16, bt.bottom - sr.top + 20]);
        }
      }
    }
    function free(x, y) { for (var i = 0; i < keepOut.length; i++) { var k = keepOut[i]; if (x > k[0] && x < k[2] && y > k[1] && y < k[3]) return false; } return true; }
    /* 规划环线：绕播放器一周（左侧空当 → 上方 → 右侧 → 下方），播放器后方的街道代价 ×25 */
    var loop = null, tunFrom = -1, tunTo = -1;
    function toUV(x, y) { var d1 = (x - ox) / A, d2 = 2 * (y - oy) / A; return [(d1 + d2) / 2, (d2 - d1) / 2]; }
    function allowed(u, v) { var p = P(u, v, 0); return p[0] > W * .03 && p[0] < W * .99 && p[1] > topY && p[1] < H * .97 && free(p[0], p[1]); }
    function nodeCost(u, v) { var p = P(u, v, 0); return inPlayer(p[0], p[1]) ? 40 : 1; }
    function snap(x, y) {
      var uv = toUV(x, y), bu = Math.round(uv[0] / B) * B, bv = Math.round(uv[1] / B) * B, best = null, bd = 1e9;
      for (var a = -3; a <= 3; a++) for (var b = -3; b <= 3; b++) {
        var u = bu + a * B, v = bv + b * B; if (!allowed(u, v)) continue;
        var p = P(u, v, 0), d = Math.hypot(p[0] - x, p[1] - y) + (inPlayer(p[0], p[1]) ? 400 : 0);
        if (d < bd) { bd = d; best = [u, v]; }
      }
      return best;
    }
    var used = {};
    function ek(a, b) { var k1 = a[0] + ',' + a[1], k2 = b[0] + ',' + b[1]; return k1 < k2 ? k1 + '|' + k2 : k2 + '|' + k1; }
    function path(a, b) {   // Dijkstra（节点不多，用数组做优先队列）；走过的街道再走代价更高
      var key = function (n) { return n[0] + ',' + n[1]; }, dist = {}, prev = {}, open = [[0, a]], seen = {};
      dist[key(a)] = 0;
      for (var guard = 0; open.length && guard < 20000; guard++) {
        open.sort(function (x, y) { return x[0] - y[0]; }); var cur = open.shift(), n = cur[1], k = key(n);
        if (seen[k]) continue; seen[k] = 1;
        if (n[0] === b[0] && n[1] === b[1]) break;
        [[B, 0], [-B, 0], [0, B], [0, -B]].forEach(function (d) {
          var m = [n[0] + d[0], n[1] + d[1]], km = key(m); if (seen[km] || !allowed(m[0], m[1])) return;
          var mid = P(n[0] + d[0] / 2, n[1] + d[1] / 2, 0); if (!free(mid[0], mid[1])) return;
          var nd = dist[k] + nodeCost(m[0], m[1]) + (inPlayer(mid[0], mid[1]) ? 40 : 0) + (used[ek(n, m)] ? 12 : 0);
          if (dist[km] === undefined || nd < dist[km]) { dist[km] = nd; prev[km] = n; open.push([nd, m]); }
        });
      }
      if (!seen[key(b)]) return null;
      var out = [b], c = b; while (key(c) !== key(a)) { c = prev[key(c)]; if (!c) return null; out.unshift(c); }
      return out;
    }
    function planLoop() {
      loop = null; if (!player || !copy) return;
      var sr = cv.getBoundingClientRect(), pr = player.getBoundingClientRect(), cr = copy.getBoundingClientRect();
      var pl = pr.left - sr.left, pt = pr.top - sr.top, pR = pr.right - sr.left, pB = pr.bottom - sr.top, cR = cr.right - sr.left;
      var gx = (cR + pl) / 2, ty = (topY + pt) / 2, by = (pB + H * .97) / 2, rx = Math.min(W * .97, (pR + W) / 2);
      var wps = [[gx, ty], [rx, ty], [rx, by], [gx, by]].map(function (q) { return snap(q[0], q[1]); });
      if (wps.some(function (q) { return !q; })) return;
      var full = []; used = {};
      for (var i = 0; i < 4; i++) {
        var seg = path(wps[i], wps[(i + 1) % 4]); if (!seg) return;
        for (var q = 1; q < seg.length; q++) used[ek(seg[q - 1], seg[q])] = 1;
        full = full.concat(i ? seg.slice(1) : seg);
      }
      full.pop();   // 首尾同一点
      // 去掉 A → B → A 的折返（剩下的点太少就保留原环线）
      var raw = full.slice();
      for (var g = 0; g < 50; g++) {
        var cut = -1, L0 = full.length;
        for (var x = 0; x < L0; x++) { var pa = full[(x - 1 + L0) % L0], pb = full[(x + 1) % L0]; if (pa[0] === pb[0] && pa[1] === pb[1]) { cut = x; break; } }
        if (cut < 0) break;
        full.splice(cut, 1); if (full.length) full.splice(cut % full.length, 1);
      }
      if (full.length < 8) full = raw;
      loop = full;
      // 隧道段：右侧那一段中间的两条边
      var r0 = full.findIndex(function (n) { return n[0] === wps[1][0] && n[1] === wps[1][1]; }), r1 = full.findIndex(function (n) { return n[0] === wps[2][0] && n[1] === wps[2][1]; });
      var mid = Math.floor((r0 + r1) / 2); tunFrom = mid - 1; tunTo = mid + 1;
      // 窗格外比例（供调试）
      var outN = 0; for (var j = 0; j < full.length; j++) { var a = full[j], b = full[(j + 1) % full.length], m = P((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, 0); if (!inPlayer(m[0], m[1])) outN++; }
      sec.setAttribute('data-route-out', (outN / full.length).toFixed(2));
      buildTrack(); placeDots();
    }
    /* 圆润轨道：每个转角改为二次曲线圆弧，按弧长匀速行驶 */
    var track = null, trackLen = 0;
    function buildTrack() {
      track = null; if (!loop || loop.length < 4) return;
      var pts = [], n = loop.length, R = 1.4;
      for (var k = 0; k < n; k++) {
        var a = loop[(k - 1 + n) % n], c = loop[k], b = loop[(k + 1) % n];
        var din = [Math.sign(c[0] - a[0]), Math.sign(c[1] - a[1])], dout = [Math.sign(b[0] - c[0]), Math.sign(b[1] - c[1])];
        var tun = k > tunFrom && k <= tunTo;
        if (din[0] === dout[0] && din[1] === dout[1]) { pts.push([c[0], c[1], tun]); continue; }
        var p0 = [c[0] - din[0] * R, c[1] - din[1] * R], p2 = [c[0] + dout[0] * R, c[1] + dout[1] * R];
        for (var t = 0; t <= 1.0001; t += 1 / 8) {
          var u = 1 - t; pts.push([u * u * p0[0] + 2 * u * t * c[0] + t * t * p2[0], u * u * p0[1] + 2 * u * t * c[1] + t * t * p2[1], tun]);
        }
      }
      var acc = 0; pts[0].push(0);
      for (var i = 1; i < pts.length; i++) { acc += Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]); pts[i].push(acc); }
      trackLen = acc + Math.hypot(pts[0][0] - pts[pts.length - 1][0], pts[0][1] - pts[pts.length - 1][1]);
      track = pts;
    }
    function trackAt(sd) {
      sd = ((sd % trackLen) + trackLen) % trackLen;
      for (var i = 1; i <= track.length; i++) {
        var b = track[i % track.length], a = track[i - 1], sb = i < track.length ? b[3] : trackLen;
        if (sd <= sb) { var f = (sd - a[3]) / Math.max(1e-6, sb - a[3]); return [a[0] + (b[0] - a[0]) * f, a[1] + (b[1] - a[1]) * f, a[2]]; }
      }
      return [track[0][0], track[0][1], track[0][2]];
    }
    /* 知识点放在轨道上的空旷处，让轨迹从中穿过 */
    function placeDots() {
      var ks = sec.querySelectorAll('.kmx-rec__kd'); if (!track || !ks.length) return;
      var stage = sec.querySelector('.kmx-rec__stage'); if (!stage) return;
      var srC = cv.getBoundingClientRect(), srS = stage.getBoundingClientRect();
      var good = function (p) {
        return !inPlayer(p[0], p[1]) && free(p[0], p[1]) && p[1] > topY + 30 && p[1] < H - 40 && p[0] > 40 && p[0] < W - 40 &&
          !(p[0] > W - 380 && p[1] < topY + 90);   // 避开右上角读数
      };
      var picks = [], starts = [.12, .55];
      starts.forEach(function (f0) {
        for (var f = f0; f < f0 + .4; f += .01) {
          var q = trackAt(f * trackLen), p = P(q[0], q[1], 0);
          if (!good(p)) continue;
          if (picks.some(function (o) { return Math.hypot(o[0] - p[0], o[1] - p[1]) < 260 || Math.abs(o[1] - p[1]) < 40; })) continue;
          picks.push(p); break;
        }
      });
      Array.prototype.forEach.call(ks, function (k, i) {
        var p = picks[i]; if (!p) return;
        k.style.left = (p[0] + srC.left - srS.left) + 'px'; k.style.top = (p[1] + srC.top - srS.top) + 'px'; k.style.right = 'auto';
      });
    }
    function nextEdge(w) {
      if (loop) {
        w.i = (w.i + 1) % loop.length; var n = loop[w.i];
        w.du = Math.sign(n[0] - w.u); w.dv = Math.sign(n[1] - w.v); w.tu = n[0]; w.tv = n[1];
        w.tun = w.i > tunFrom && w.i <= tunTo; return;
      }
      var opts = [[1, 0], [-1, 0], [0, 1], [0, -1]].filter(function (d) { return !(d[0] === -w.du && d[1] === -w.dv); });
      var straight = opts.filter(function (d) { return d[0] === w.du && d[1] === w.dv; });
      var d = (straight.length && Math.random() < .6) ? straight[0] : opts[Math.floor(Math.random() * opts.length)];
      // 不走出画面：目标路口投影到画外就换方向
      var ok = function (dd) {
        var p = P(w.u + dd[0] * B, w.v + dd[1] * B, 0), m = P(w.u + dd[0] * B / 2, w.v + dd[1] * B / 2, 0);
        return p[0] > W * .05 && p[0] < W * .99 && p[1] > topY && p[1] < H * .97 && free(p[0], p[1]) && free(m[0], m[1]);
      };
      // 优先走播放器以外的路口，没有可走的才从播放器后方穿过
      var outP = function (dd) { var p = P(w.u + dd[0] * B, w.v + dd[1] * B, 0); return !inPlayer(p[0], p[1]); };
      var good = opts.filter(ok), vis = good.filter(outP);
      if (!(ok(d) && outP(d))) d = vis.length ? vis[Math.floor(Math.random() * vis.length)] : good.length ? good[Math.floor(Math.random() * good.length)] : [-w.du, -w.dv];
      w.du = d[0]; w.dv = d[1]; w.tu = w.u + d[0] * B; w.tv = w.v + d[1] * B; w.tun = Math.random() < .12;
    }
    function drawFrame(now) {
      if (!cx2 || !W) return;
      cx2.setTransform(DPR, 0, 0, DPR, 0, 0); cx2.clearRect(0, 0, W, H);
      cx2.drawImage(cache, 0, 0, W, H);
      var LIFE = 4500;
      while (trail.length && now - trail[0].t > LIFE) trail.shift();
      var hs = walker ? walker.u + walker.v : 0;
      // 线头附近的楼体：先更新提亮值；在线头后方的楼先画，前方的楼在轨迹之后再画（遮住轨迹）
      cx2.lineWidth = .7;
      var front = [];
      if (walker) for (var j = 0; j < blds.length; j++) {
        var bl = blds[j], mu = (bl.u0 + bl.u1) / 2, mv = (bl.v0 + bl.v1) / 2;
        var dd = Math.hypot(mu - walker.u, mv - walker.v), near = Math.max(0, 1 - dd / 5);
        bl.g = Math.max(near, bl.g * .97);
        if (bl.g > .02) drawB(cx2, bl, bl.g);
      }
      cx2.lineCap = 'round'; cx2.lineJoin = 'round';
      for (var i = 1; i < trail.length; i++) {
        var a = trail[i - 1], b = trail[i], f = 1 - (now - b.t) / LIFE;
        var pa = P(a.u, a.v, 0), pb = P(b.u, b.v, 0);
        cx2.setLineDash(b.tun ? [3, 4] : []);
        cx2.strokeStyle = b.tun ? 'rgba(217,119,6,' + (.9 * f) + ')' : 'rgba(52,152,219,' + (.92 * f) + ')';
        cx2.lineWidth = 1.8 + 1.2 * f; cx2.beginPath(); cx2.moveTo(pa[0], pa[1]); cx2.lineTo(pb[0], pb[1]); cx2.stroke();
      }
      cx2.setLineDash([]);
      if (walker) {
        var h = P(walker.u, walker.v, 0), tun = walker.tun;
        var gr = cx2.createRadialGradient(h[0], h[1], 0, h[0], h[1], 30);
        gr.addColorStop(0, tun ? 'rgba(217,119,6,.28)' : 'rgba(124,200,255,.42)'); gr.addColorStop(1, 'rgba(255,255,255,0)');
        cx2.fillStyle = gr; cx2.beginPath(); cx2.arc(h[0], h[1], 30, 0, 7); cx2.fill();
        cx2.fillStyle = tun ? '#b45309' : '#1f84c9'; cx2.beginPath(); cx2.arc(h[0], h[1], 3, 0, 7); cx2.fill();
        cx2.lineWidth = .7;
      }
    }
    function tick(now) {
      if (!running) return;
      var dt = Math.min(64, now - (lastT || now)); lastT = now;
      var w = walker; if (w) {
        var sp = dt / 1000 * 3.2;   // 每秒约 3.2 格
        if (w.onTrack && track) { w.s += sp; var q = trackAt(w.s); w.u = q[0]; w.v = q[1]; w.tun = q[2]; }
        else {
          var ru = w.tu - w.u, rv = w.tv - w.v, rem = Math.abs(ru) + Math.abs(rv);
          if (rem <= sp) { w.u = w.tu; w.v = w.tv; nextEdge(w); } else { w.u += w.du * sp; w.v += w.dv * sp; }
        }
        trail.push({ u: w.u, v: w.v, t: now, tun: w.tun });
      }
      drawFrame(now);
      requestAnimationFrame(tick);
    }
    function cityRun(v) {
      if (reduce || !cv) return;
      if (v && !running) { running = true; lastT = 0; requestAnimationFrame(tick); } else if (!v) running = false;
    }

    /* ---------- 播放器 ---------- */
    function load(v) {
      var s = v && v.querySelector('source');
      if (s && !s.getAttribute('src')) { v.preload = 'auto'; s.setAttribute('src', s.getAttribute('data-src')); v.load(); }
    }
    // 预载：当前片段可以播放后，后台加载下一段；悬停 / 聚焦页签时提前加载对应片段
    function preloadNext() { var n = vids[(cur + 1) % vids.length]; if (n && n !== vids[cur]) load(n); }
    function syncPP() {
      var v = vids[cur], playing = v && !v.paused && !v.ended;
      pp.classList.toggle('is-paused', !playing);
      pp.setAttribute('aria-label', playing ? pp.dataset.pause : pp.dataset.play);
    }
    function play() {
      var v = vids[cur]; if (!v) return;
      if (!wantPlay || !visible) { v.pause(); syncPP(); return; }
      var p = v.play();
      if (p && p.catch) p.catch(function (err) {
        // 只有当前片段被浏览器明确拒绝自动播放时才停；切换时被打断的 play() 忽略
        if (v === vids[cur] && err && err.name === 'NotAllowedError') { wantPlay = false; syncPP(); }
      });
    }
    function show(i) {
      if (i === cur) return;
      var prev = cur;
      vids.forEach(function (v, n) { if (n !== i) { v.pause(); v.classList.remove('is-on'); } });
      cur = i;
      var v = vids[i]; load(v);
      try { v.currentTime = 0; } catch (e) { /* 未加载时忽略 */ }
      v.classList.add('is-on');
      tabs.forEach(function (t, n) {
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
        t.querySelector('.kmx-rec__prog i').style.width = (n === prev && prev !== i) || n < i ? '100%' : '0';
      });
      var label = v.dataset.label || '';
      q('bar-scene').textContent = label; q('scene').textContent = label;
      q('idx').textContent = (i + 1) + '/' + vids.length; q('speed').textContent = v.dataset.speed || '';
      var isDr = v.dataset.dr === '1';
      sec.setAttribute('data-dr', isDr ? '1' : '0');
      if (dr) { dr.hidden = !isDr; dr.classList.remove('is-on'); }
      play();
    }
    vids.forEach(function (v, n) {
      v.addEventListener('timeupdate', function () {
        if (n !== cur || !v.duration) return;
        var f = v.currentTime / v.duration;
        tabs[n].querySelector('.kmx-rec__prog i').style.width = (f * 100).toFixed(1) + '%';
        if (KMX.progress) KMX.progress(sec, f);
        // 隧道片段：GT-01 54 s 片段第 6–51 s 为 INS 段
        if (dr && v.dataset.dr === '1') dr.classList.toggle('is-on', f > (parseFloat(v.dataset.drAt) || .11) && f < (parseFloat(v.dataset.drEnd) || .945));
      });
      v.addEventListener('ended', function () { if (n === cur) show((cur + 1) % vids.length); });
      v.addEventListener('play', syncPP); v.addEventListener('pause', syncPP);
    });
    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () { wantPlay = true; if (n === cur) { play(); return; } show(n); });
      t.addEventListener('pointerenter', function () { load(vids[n]); }); t.addEventListener('focus', function () { load(vids[n]); });
    });
    vids.forEach(function (v, n) { v.addEventListener('canplaythrough', function () { if (n === cur) setTimeout(preloadNext, 400); }); });
    pp.addEventListener('click', function () {
      var v = vids[cur]; if (!v) return;
      if (v.paused) { wantPlay = true; play(); } else { wantPlay = false; v.pause(); }
    });

    // 知识点：提示卡会超出视口右缘时改为朝左
    Array.prototype.forEach.call(sec.querySelectorAll('.kmx-rec__kd'), function (k) {
      function place() {
        var tip = k.querySelector('.kmx-kdot__tip'); if (!tip) return;
        k.classList.remove('is-flip');
        if (k.getBoundingClientRect().right + tip.getBoundingClientRect().width + 24 > window.innerWidth) k.classList.add('is-flip');
      }
      k.addEventListener('mouseenter', place); k.addEventListener('focus', place);
    });

    // 左栏：标题对齐播放器顶边，按钮对齐播放器底边
    function align() {
      if (copy && player) {
        copy.style.setProperty('--rec-pt', '0px'); copy.style.setProperty('--rec-pb', '0px');
        if (!mq.matches) {
          var cr = copy.getBoundingClientRect(), pr = player.getBoundingClientRect();
          copy.style.setProperty('--rec-pt', Math.max(0, pr.top - cr.top) + 'px');
          copy.style.setProperty('--rec-pb', Math.max(0, cr.bottom - pr.bottom) + 'px');
        }
        // 知识点按播放器实际位置摆放：上方一个、左侧下部一个
        var t = sec.querySelector('.kmx-rec__kd--top'), d = sec.querySelector('.kmx-rec__kd--side');
        if (t) t.style.top = (player.offsetTop - 30) + 'px';
        if (d) d.style.top = (player.offsetTop + player.offsetHeight * .72) + 'px';
      }
    }
    align(); window.addEventListener('resize', align); window.addEventListener('load', function () { align(); buildCity(); });
    buildCity(); window.addEventListener('resize', function () { buildCity(); });

    show(0); syncPP();
    KMX.onVisible(sec, function (v) { visible = v; if (!v && !reduce) wantPlay = true; play(); cityRun(v); }); // 离开后恢复自动播放
    if (!window.IntersectionObserver) { visible = true; play(); cityRun(true); }
  }

  function boot() { document.querySelectorAll('.kmx-rec').forEach(initRecord); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('.kmx-rec'); if (s) initRecord(s); });
})();
